import { Box, Paper } from '@mui/material'
import { PlayerSearchTableComponent } from './'

export const PlayerSearchModule = () => {
  return (
    <Box
      component={Paper}
      sx={{
        minHeight: 'calc(100vh - 168px)',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 2,
        width: '100%',
      }}
    >
      <PlayerSearchTableComponent />
    </Box>
  )
}
